<template>
  <div class="tag">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <img class="card-icon" src="../assets/biaoqian.png" />
        <span>{{"标签"}}</span>
      </div>
      <div class="text item">
        <el-tag size="medium" v-for="(item,index) in categoryList" :key="item.id" :value="item" class="tag" :type="typeList[index%typeList.length]" @click="tag(item.categoryName)">{{item.categoryName}}[{{queryTagArticleNum(index)}}]</el-tag>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "tag",
  data() {
    return {
      typeList: ["", "success", "info", "warning", "danger"],
    };
  },
  computed: {
    categoryList() {
      return this.$store.state.categoryList;
    },
  },
  methods: {
    tag(name) {
      this.$store.commit("setActiveIndex", "/archive");
      this.$router.push({
        name: "tag",
        params: {
          name: name,
        },
      });
    },
    queryTagArticleNum(index) {
      return this.$store.state.categoryArticleNumList[index];
    }
  },
};
</script>

<style scoped>
.box-card .item:hover {
  color: #409eff;
  cursor: pointer;
}

.box-card span {
  font-weight: bold;
}

.card-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}

.tag {
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>